import React from 'react';
import PropTypes from 'prop-types';
import ReactQuill from 'react-quill';

import { Button } from 'react-bootstrap';

import 'react-quill/dist/quill.snow.css';

const Comments = props => (
  <div className='comments'>
    <h4>{props.title}</h4>
    <div className='comment-box'>
      <ReactQuill
        value={props.comments}
        placeholder=''
        style={{
          width: '100%',
          backgroundColor: '#FFF',
        }}
        onChange={(value) => { props.update(value); }}
      />
    </div>
    <div className='actions' style={{ marginTop: '28px' }}>
      <Button bsStyle='danger'>
        Cancel
      </Button>
      <Button bsStyle='primary'>
        Send
      </Button>
    </div>
  </div>
);

Comments.propTypes = {
  title: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.string]),
  comments: PropTypes.string,
  update: PropTypes.func.isRequired,
};

Comments.defaultProps = {
  title: '',
  comments: '',
};

export default Comments;



// WEBPACK FOOTER //
// ./src/views/Components/Comments.js